import "./Footer.scss";
import whiteLogo from "../../../assets/logos/HUM-AI-Logo-Full-Mark-White.svg";
import blackLogo from "../../../assets/logos/HUM-AI-Logo-Full-Mark-Black.svg";
import { NavLink, Link } from "react-router-dom";
import { FaLinkedin } from "react-icons/fa";
import { useTheme } from "../../../context/ThemeContext";

function Footer({ CLOUDFRONT_URL }) {
  const { theme } = useTheme();
  const copyrightYear = new Date().getFullYear();
  const copyrightContent = <>&copy; HUM.AI {copyrightYear}</>;

  // Choose the logo based on theme
  const logo = theme.logoVariant === "black" ? blackLogo : whiteLogo;

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__content">
          <div className="footer__logo">
            <Link to="/">
              <img src={logo} alt="HUM AI Logo" className="footer__logo" />
            </Link>
          </div>
          <div className="footer__links">
            <div className="footer__links-column">
              <header><b>Company</b></header>
              <NavLink className="footer__link" to="https://jobs.ashbyhq.com/hum-ai/">
                careers
              </NavLink>
              <NavLink className="footer__link" to="mailto:founders@hum.ai">
                contact
              </NavLink>
              <NavLink className="footer__link" to="/research">
                research
              </NavLink>
              {/* <NavLink className="footer__link" to="/blog">
                blog
              </NavLink> */}
            </div>
            <div className="footer__links-column">
              <header><b>Legal</b></header>
              <NavLink className="footer__link" to="/privacy-policy">
                privacy policy
              </NavLink>
            </div>
            <div className="footer__links-column">
              <header><b>Social</b></header>
              <a href="https://www.linkedin.com/company/hum-ai">
                <FaLinkedin />
              </a>
            </div>
          </div>
        </div>
        <div className="footer__copyright">{copyrightContent}</div>
      </div>
    </footer>
  );
}

export default Footer;
